import {settingService} from '../../../router'
import { i18n } from '../../../i18n'

/**
 * Send LMS message.
 * @param {SendLmsMessageProps} props Send LMS message props
 * @return {Promise<(boolean|string)[]>}
 */
export const sendLmsMessage = async ({numbers, message, bytes}) => {
  const isNumbersArrayType = Array.isArray(numbers)
  if (!isNumbersArrayType) return [false, i18n.t('sms.noContact')]
  // Filtering.
  const filteredNumbers = numbers.filter((number) => !!number)
  if (!filteredNumbers.length) return [false, i18n.t('sms.noContact')]
  // Parsing.
  const parsedNumbers = filteredNumbers.map((number) => {
    const isPhoneNumberTester = new RegExp(/(\d{3})-(\d{4})-(\d{4})/, 'g')
    const isValidPhoneNumber = isPhoneNumberTester.test(number)
    if (isValidPhoneNumber) return number

    const isValidDigitsTester = new RegExp(/[0-9]{11}/, 'g')
    const isValidDigits = isValidDigitsTester.test(number)
    if (isValidDigits) {
      const first = number.slice(0, 3)
      const second = number.slice(3, 7)
      const third = number.slice(7, 14)
      return `${first}-${second}-${third}`
    }
    return number
  })

  try {
    const { statusCode } = await settingService.sendSMS({
      numbers: parsedNumbers,
      message,
      bytes
    })
    if (statusCode !== 200) return [false, i18n.t('sms.sendFailed')]
    return [true, i18n.t('sms.sendSuccess')]
  } catch (error) {
    console.error('[sendLmsMessage]', error)
    return [false, i18n.t('sms.sendFailed')]
  }
}



// WEBPACK FOOTER //
// ./src/features/sms/services/sms.service.js